/**
 * Connects the shared `ErpEnvironmentBanner` to the claimflow data layer.
 *
 * Rendered inside `ClaimFlowAuthGuard` (via `ClaimFlowLayout`), so the fetch is
 * authenticated and tenant-scoped. While loading — or if the fetch fails — it
 * renders nothing rather than guessing an environment.
 */

import { ErpEnvironmentBanner } from '@/shared/erp';
import { useClaimflowErpRegistries } from '../hooks/useClaimflowErpRegistries';

export function ClaimflowEnvironmentBanner() {
  const { data } = useClaimflowErpRegistries();

  return <ErpEnvironmentBanner registries={data ?? []} />;
}
